import Image from 'next/image'

import exploreEvents from '@/utils/gaEvents/exploreEvents'

import Shared from '@/shared'

import type { PARKINGLOT_TYPE } from '@/enums/detail'
import { CATE_CATEGORY } from '@/enums/gtagEvents'

interface AppBannerProps {
  parkinglotSeq: number | null
  isPartner?: boolean
  latitude: number
  longitude: number
  type: PARKINGLOT_TYPE
}

const AppBanner = ({ parkinglotSeq, isPartner, latitude, longitude, type }: AppBannerProps) => {
  const handleClick = () => {
    if (parkinglotSeq == null) return
    const url = Shared.Utils.getMapParkinglotURL(
      {
        parkinglotType: type,
        parkinglotSeq: parkinglotSeq,
        lat: latitude,
        lng: longitude
      },
      'parkinglotdetail'
    )
    if (isPartner === undefined) {
      exploreEvents.shared.onClickAppBannerButton(parkinglotSeq)
    } else {
      exploreEvents.partner.onClickAppBannerButton(
        isPartner ? CATE_CATEGORY.PARTNER : CATE_CATEGORY.NORMAL,
        parkinglotSeq
      )
    }
    window.open(url, '_blank')
  }
  return (
    <div className="mt-[24px] h-[86px] w-full cursor-pointer bg-main-020" onClick={handleClick}>
      <Image
        src="/images/img_app_banner.png"
        alt="앱배너 이미지"
        width={360}
        height={86}
        unoptimized
        className="h-full w-full object-contain"
      />
    </div>
  )
}

export default AppBanner
